<template>
  <d2-container>
    <template slot="header">
      <el-form
        :inline="true"
        :model="searchForm"
        ref="searchForm"
        size="mini"
        style="margin-bottom: -18px;"
      >
        <el-form-item
          label="举报类型"
          prop="complaint_type"
        >
          <el-input
            v-model="searchForm.complaint_type"
            placeholder="举报类型"
            style="width: 100px;"
          />
        </el-form-item>

        <el-form-item>
          <el-select
                  class="filter-item"
                  v-model="searchForm.state"
                  placeholder="状态"
                  width="50"
          >
            <el-option
                    v-for="item in typeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="handleSearchFormSubmit"
          >
            <d2-icon name="search" /> 查询
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button @click="handleSearchFormReset">
            <d2-icon name="refresh" /> 重置
          </el-button>
        </el-form-item>
      </el-form>
    </template>
    <el-table
      :data="tableData"
      v-loading="loading"
      size="small"
      stripe
      highlight-current-row
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
    >

      <el-table-column
        type="selection"
        width="55"
      >
      </el-table-column>
      <el-table-column
        label="举报人编号"
      >
        <template slot-scope="scope">
          {{scope.row.agentid}}
        </template>
      </el-table-column>

      <el-table-column
              label="举报人微信名称"
      >
        <template slot-scope="scope">
          {{scope.row.agentname}}
        </template>
      </el-table-column>

      <el-table-column
        label="举报类型"
        prop="complaint_type"
        sortable="custom"
        :show-overflow-tooltip="true"
        width="150"
      >
        <template slot-scope="scope">
          {{scope.row.complaint_type}}
        </template>
      </el-table-column>
      <el-table-column
        label="图片"
        :show-overflow-tooltip="true"
        width="150"
      >
        <template slot-scope="scope">
          <img :src= "getImgUrl(scope.row)" style="width: 100px;height: 100px; "/>
        </template>
      </el-table-column>
      <el-table-column
        label="举报商家"
        prop="sort_id"
        sortable="custom"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.shop_agentname}}
        </template>
      </el-table-column>
      <el-table-column
              label="提交时间"
              prop="complaint_times"
              width="150"
      >
        <template slot-scope="scope">
          {{scope.row.complaint_times}}
        </template>
      </el-table-column>
      <el-table-column
              label="状态"
              prop="sort_id"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.state=='0'">
            审核通过
          </div>
          <div v-else-if="scope.row.state=='1'">
            未处理
          </div>
          <div v-else-if="scope.row.state=='2'">
            审核不通过
          </div>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        align="center"
        width="250"
      >
        <template slot-scope="scope">
          <el-button type="primary" plain  size="mini"          v-if="scope.row.state=='1'"  @click="openEditForm(scope.row)">审批</el-button>
          <el-button
                  type="primary"
                  plain
                  size="mini"
                  @click="openViewForm(scope.row)"
          >详情</el-button>

        </template>
      </el-table-column>

    </el-table>
    <template slot="footer">
      <el-pagination
        :current-page="page.current"
        :page-size="page.size"
        :total="page.total"
        :page-sizes="[1,10,50,100, 200, 300, 400]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: -10px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </template>
    <edit-form
      :oneclass="oneclass"
      v-model="editFormVisible"
      @submit="getTableData"
    />
    <view-form
            :oneclass="oneclass"
            v-model="viewFormVisible"
            @submit="getTableData"
    />

  </d2-container>
</template>
<script>
import * as oneclassService from '@/api/sys/oneclass'
import util from '@/libs/util.js'
import editForm from './editForm'
import viewForm from './viewForm'
export default {
  name: 'OneclassPage',
  components: { editForm, viewForm },
  data () {
    return {
      searchForm: {
        advTitle: ''
      },
      typeOptions: [
        {
          value: '0',
          label: '审核通过'
        },
        {
          value: '1',
          label: '未处理'
        }, {
          value: '2',
          label: '审核不通过'
        }
      ],
      is_agentid: '',
      loading: false,
      tableData: [],
      multipleSelection: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      sort: {
        prop: '',
        order: ''
      },
      oneclass: {},
      viewFormVisible: false,
      editFormVisible: false
    }
  },
  mounted () {
    if (util.cookies.get('agentid') == null || util.cookies.get('agentid') == '') {
      this.is_agentid = '7080007'
    } else {
      this.is_agentid = util.cookies.get('agentid')
    }
    this.getTableData()
  },
  methods: {
    getTableData () {
      let query = {
        pageIndex: this.page.current,
        pageSize: this.page.size,
        sortBy: this.sort.prop,
        xt_id: util.cookies.get('xt_id'),
        descending: this.sort.order === 'descending',
        filter: this.searchForm
      }
      oneclassService.getComplaintPagedList(query).then(data => {
        this.tableData = data.rows
        this.page.total = data.totalCount
      })
    },
    getImgUrl (row) {
      return 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + row.complaint_img
    },
    handleSearchFormSubmit () {
      this.getTableData()
    },
    handleSearchFormReset () {
      this.$refs.searchForm.resetFields()
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    handleSortChange (val) {
      this.sort.prop = val.prop
      this.sort.order = val.order
      this.getTableData()
    },
    handleSizeChange (val) {
      this.page.size = val
      this.getTableData()
    },
    handleCurrentChange (val) {
      this.page.current = val
      this.getTableData()
    },
    openEditForm (oneclass) {
      this.oneclass = oneclass
      this.editFormVisible = true
    },
    openViewForm (oneclass) {
      this.oneclass = oneclass
      this.viewFormVisible = true
    },
    add () {
      this.oneclass = {}
      this.editFormVisible = true
    },
    update (id, type) {
      let msg = type == 1 ? '禁用' : '恢复'
      this.$confirm('确认' + msg + '操作？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: msg,
        cancelButtonText: '取消'
      }).then(() => {
        oneclassService.updateOneclass({ id: id, state: type }).then(() => {
          this.getTableData()
        })
      })
    },
    batchDel () {
      this.$confirm('确认删除？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '删除',
        cancelButtonText: '取消'
      }).then(() => {
        oneclassService
          .delOneclasss({
            ids: JSON.stringify(this.multipleSelection.map(s => s.id))
          })
          .then(() => {
            this.getTableData()
          })
      })
    },
    del (id) {
      this.$confirm('确认删除？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '删除',
        cancelButtonText: '取消'
      }).then(() => {
        oneclassService.delOneclass({ id: id }).then(() => {
          this.getTableData()
        })
      })
    }
  }
}
</script>
